import axios from "axios";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();
const token = localStorage.getItem("accessToken");

export async function getGames() {
  try {
    const response = await api.get("merchant/games", null);
    // API may return { data: [...] } or the array directly
    const list = response?.data ?? response;
    return Array.isArray(list) ? list : [];
  } catch (error) {
    throw new Error("Games could not be loaded");
  }
}

export async function createGame(payload) {
  try {
    const response = await axios.post("merchant/create-game", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Games could not be created");
  }
}

export async function fetchGameById(gameId) {
  try {
    const response = await axios.get(`merchant/game-details/${gameId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // Axios interceptor returns response.data (the body). game-details returns GameDTO directly as body.
    return response;
  } catch (error) {
    console.error(error);
    throw new Error(error?.message || `Game with ID ${gameId} could not be fetched`);
  }
}

// Update game by ID
export async function updateGame(gameId, payload) {
  try {
    const response = await axios.patch(
      `merchant/update-game/${gameId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(`Game with ID ${gameId} could not be updated`);
  }
}

// Delete games by IDs
export async function deleteGames(ids) {
  try {
    const response = await axios.delete("merchant/delete-games", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { ids }, // Sending data as part of the request body
    });
    return response.data;
  } catch (error) {
    console.error(
      "Failed to delete games:",
      error.response?.data || error.message
    );
    throw new Error("Games could not be deleted");
  }
}
